import { SVGAttributes } from 'react';

export const LeftRightArrowIcon = (props: SVGAttributes<SVGAElement>) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={props.className}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.17807 12.9069C1.94064 12.6695 1.94064 12.2846 2.17807 12.0471L6.04713 8.17807C6.28456 7.94064 6.6695 7.94064 6.90692 8.17807C7.14435 8.41549 7.14435 8.80044 6.90692 9.03786L4.07572 11.8691L20.5951 11.8691L17.7639 9.03786C17.5264 8.80044 17.5264 8.4155 17.7639 8.17807C18.0013 7.94065 18.3862 7.94065 18.6237 8.17807L22.4927 12.0471C22.7301 12.2846 22.7301 12.6695 22.4927 12.9069L18.6237 16.776C18.3862 17.0134 18.0013 17.0134 17.7639 16.776C17.5264 16.5386 17.5264 16.1536 17.7639 15.9162L20.5951 13.085L4.07572 13.085L6.90692 15.9162C7.14435 16.1536 7.14435 16.5386 6.90692 16.776C6.6695 17.0134 6.28455 17.0134 6.04713 16.776L2.17807 12.9069Z"
			fill={'currentColor'}
		/>
	</svg>
);
